import type { EBillingAccount } from "@/modules/billing/billingLogic.tsx";
import type { MethodFees } from "@/modules/billing/paymentMethods.ts";
import type { SiteAmount } from "@/modules/currency/currencyTypes.ts";
import type { ProcessorCurrencyFee } from "@warrenio/api-spec/spec.oats.gen";

export function getCountryCurrencyFees(
    account: EBillingAccount,
    config: ProcessorCurrencyFee,
    country: string | null | undefined,
): ProcessorCurrencyFee | undefined {
    const baCountry = account.account.country?.toUpperCase();
    const cardCountry = country?.toUpperCase();
    if (!baCountry) {
        console.warn(`Account ${account.id} has no country set`);
        return undefined;
    }

    const forCountry = config.for_country;
    const countryExists: boolean = !!cardCountry || !!baCountry;
    if (!!forCountry && countryExists && forCountry !== cardCountry && forCountry !== baCountry) {
        return undefined;
    }

    return config;
}

export interface CalculatedFees {
    baseFee: SiteAmount;
    feePercent: number;
    transactionFee: SiteAmount;
    vatAmount: SiteAmount;
    total: SiteAmount;
}

export function getCalculatedFees(fees: MethodFees, amount: SiteAmount, vat_percentage: number): CalculatedFees {
    const baseFee = (fees?.service_fee?.flat_rate ?? 0) as SiteAmount;
    const feePercent = fees?.service_fee?.percentage ?? 0;

    const totalFee = baseFee + amount * (feePercent / 100);
    const vatMultiplier = 1 + vat_percentage / 100;
    const total = ((amount + totalFee) * vatMultiplier) as SiteAmount;

    const transactionFee = (baseFee + amount * (feePercent / 100)) as SiteAmount;
    const vatAmount = (vat_percentage !== 0 ? ((amount + transactionFee) * vat_percentage) / 100 : 0) as SiteAmount;

    return { baseFee, feePercent, total, vatAmount, transactionFee };
}
